/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FRDIds
 */
export interface FRDIds {
  /**
   *
   * @type {string}
   * @memberof FRDIds
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof FRDIds
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof FRDIds
   */
  deliveryAccountableParty?: string | null;
  /**
   *
   * @type {string}
   * @memberof FRDIds
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the FRDIds interface.
 */
export function instanceOfFRDIds(value: object): value is FRDIds {
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function FRDIdsFromJSON(json: any): FRDIds {
  return FRDIdsFromJSONTyped(json, false);
}

export function FRDIdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FRDIds {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    broId: json["bro_id"],
    deliveryAccountableParty:
      json["delivery_accountable_party"] === undefined
        ? undefined
        : json["delivery_accountable_party"] === null
        ? null
        : json["delivery_accountable_party"],
    dataOwner: json["data_owner"],
  };
}

export function FRDIdsToJSON(json: any): FRDIds {
  return FRDIdsToJSONTyped(json, false);
}

export function FRDIdsToJSONTyped(
  value?: Omit<FRDIds, "uuid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bro_id: value["broId"],
    delivery_accountable_party: value["deliveryAccountableParty"],
    data_owner: value["dataOwner"],
  };
}
